import React from 'react';
import { Card, CardContent } from './ui/card';
import { Skeleton } from './ui/skeleton';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { ArrowRight, Info } from 'lucide-react';

const ConversionCard = ({
  title,
  leftValue,
  rightValue,
  leftLabel,
  rightLabel,
  loading = false,
  isReload = false,
}) => {
  const formatValue = (value, isReload = false) => {
    if (loading || value === null || value === undefined) {
      return <Skeleton className="w-16 h-8" />;
    }
    if (typeof value === 'string') return value;
    if (isReload) return `$${Math.round(value)}`;
    return `${(value * 100).toFixed(1)}%`;
  };

  const formatLeftValue = (value) => {
    if (typeof value === 'string') return value;
    return `${value}%`;
  };

  return (
    <Card className="h-full transition-all duration-300 hover:border-primary-500/50 hover:-translate-y-0.5 hover:shadow-brand-glow">
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-bold text-ink">{title}</h3>
          <Tooltip>
            <TooltipTrigger asChild>
              <button className="p-1 text-ink-dim opacity-70 hover:opacity-100">
                <Info className="h-4 w-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent>Information about this conversion will be available soon</TooltipContent>
          </Tooltip>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div className="text-center min-w-[80px]">
            <div className="text-2xl font-bold text-primary-500 mb-1">
              {typeof leftValue === 'string' ? leftValue : formatLeftValue(leftValue)}
            </div>
            <span className="text-xs text-ink-dim">{leftLabel}</span>
          </div>

          <ArrowRight className="h-5 w-5 text-ink-dim mx-3" />

          <div className="text-center min-w-[80px]">
            <div className="text-2xl font-bold text-ink mb-1">
              {formatValue(rightValue, isReload)}
            </div>
            <span className="text-xs text-ink-dim">{rightLabel}</span>
          </div>
        </div>

        <p className="text-center text-xs text-ink-dim opacity-80">
          Convert {leftLabel} to {rightLabel}
        </p>
      </CardContent>
    </Card>
  );
};

export default ConversionCard;
